import React, { useState, useMemo, useCallback } from 'react';
import { GridContainer, GridSection, GridItem, GridCount, customRangeSection } from './styles';
import { Row, Col, Button, InputNumber } from 'antd';
import { withTranslation, useTranslation } from 'react-i18next';
import { CONFIRMATION_PAGE_MODAL } from '../Modals/translationValues';

const NAMESPACES = ['CONFIRMATION_PAGE_MODAL'];
const GridSelectionInterface = ({
  rows = 10,
  columns = 10,
  onSelectionChange,
  setLoading,
  loading,
}) => {
  const [selectedCells, setSelectedCells] = useState([]);
  const [customRows, setCustomRows] = useState(3);
  const [customColumns, setCustomColumns] = useState(3);
  const { t } = useTranslation(NAMESPACES);

  const handleMouseEnter = useCallback((row, col) => {
    const newSelectedCells = [];
    for (let r = 1; r <= row; r++) {
      for (let c = 1; c <= col; c++) {
        newSelectedCells.push(`${r}-${c}`);
      }
    }
    setSelectedCells(newSelectedCells);
  }, []);

  const handleClick = useCallback((rows, cols) => {
    if (onSelectionChange) {
      onSelectionChange({ rows, cols });
    }
  }, []);

  const handleCustomSelection = useCallback(() => {
    if (onSelectionChange && customRows && customColumns) {
      setLoading(true);
      setTimeout(() => {
        onSelectionChange({ rows: customRows, cols: customColumns });
      }, 200);
    }
  }, [customRows, customColumns]);

  const gridItems = useMemo(() => {
    return Array.from({ length: rows }, (_, rowIndex) =>
      Array.from({ length: columns }, (_, colIndex) => {
        const row = rowIndex + 1;
        const col = colIndex + 1;
        const isSelected = selectedCells.includes(`${row}-${col}`);
        return (
          <GridItem
            key={`${row}-${col}`}
            className={isSelected ? 'selected' : ''}
            onMouseEnter={() => handleMouseEnter(row, col)}
            onClick={() => handleClick(row, col)}
            aria-label={`Select ${row} x ${col}`}
            role="button"
          />
        );
      }),
    );
  }, [rows, columns, selectedCells, handleMouseEnter, handleClick]);

  const lastSelectedCell = selectedCells[selectedCells.length - 1]?.replace('-', ' x ') || '';

  return (
    <GridContainer>
      <GridCount>{lastSelectedCell}</GridCount>
      <GridSection columns={columns} onMouseLeave={() => setSelectedCells([])}>
        {gridItems}
      </GridSection>
      <customRangeSection>
        <Row gutter={8} style={{ width: '100%' }}>
          <Col span={5} style={{ width: '43%', color: '#fff' }}>
            {t(CONFIRMATION_PAGE_MODAL.ROWS.key, CONFIRMATION_PAGE_MODAL.ROWS.value)}
            <InputNumber
              placeholder={t(CONFIRMATION_PAGE_MODAL.ROWS.key, CONFIRMATION_PAGE_MODAL.ROWS.value)}
              style={{ width: '100%' }}
              value={customRows}
              onChange={e => setCustomRows(e)}
              type="number"
              min={1}
              max={70}
              disabled={loading}
            />
          </Col>
          <Col span={5} style={{ width: '43%', color: '#fff' }}>
            {t(CONFIRMATION_PAGE_MODAL.COLUMNS.key, CONFIRMATION_PAGE_MODAL.COLUMNS.value)}
            <InputNumber
              placeholder={t(
                CONFIRMATION_PAGE_MODAL.COLUMNS.key,
                CONFIRMATION_PAGE_MODAL.COLUMNS.value,
              )}
              style={{ width: '100%' }}
              value={customColumns}
              onChange={e => setCustomColumns(e)}
              type="number"
              min={1}
              max={70}
              disabled={loading}
            />
          </Col>
          <Col span={5} style={{ width: '14%', color: '#fff', top: '25px' }}>
            <Button
              style={{ backgroundColor: '#8c52ff', borderColor: '#8c52ff', color: '#fff' }}
              icon="arrow-right"
              shape="circle"
              size="small"
              onClick={handleCustomSelection}
              loading={loading}
              disabled={loading}
            />
          </Col>
        </Row>
      </customRangeSection>
    </GridContainer>
  );
};

export default withTranslation(NAMESPACES)(GridSelectionInterface);
